import getAggregateRatingSchema from './getAggregateRatingSchema';

export default function getProductSchema(product) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    url: 'https://www.tassomutuo.it',
    name: product.name,
    description: product.description,
    image: product.image,
    aggregateRating: getAggregateRatingSchema(),
  };

  return schema;
}
